import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<aside data-part="step-preview" class="svelte-1tc0hwx"><canvas class="step-preview-canvas svelte-1tc0hwx" data-part="preview-swatch" data-preview="after"></canvas></aside>`);

const $$css = {
	hash: 'svelte-1tc0hwx',
	code: '[data-part="step-preview"].svelte-1tc0hwx {border:1px solid var(--color-panel-border-strong);border-radius:10px;background:color-mix(in srgb, var(--color-bg), var(--color-bg3) 8%);}.step-preview-canvas.svelte-1tc0hwx {display:block;width:100%;height:100%;aspect-ratio:1 / 1;border-radius:10px;image-rendering:auto;}'
};

export default function Svelte_step_preview($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const stepId = $.prop($$props, 'stepId', 7),
		stepIndex = $.prop($$props, 'stepIndex', 7),
		ariaLabel = $.prop($$props, 'ariaLabel', 7),
		computeLutUv = $.prop($$props, 'computeLutUv', 7, undefined),
		onCrosshairUvChange = $.prop($$props, 'onCrosshairUvChange', 7, () => undefined);

	let crosshairUv = $.state(null);

	$.user_effect(() => {
		onCrosshairUvChange()($.get(crosshairUv));
	});

	function handlePreviewMouseMove(event) {
		if (!computeLutUv()) {
			return;
		}

		const canvas = event.currentTarget;

		if (!canvas) {
			return;
		}

		const rect = canvas.getBoundingClientRect();

		if (rect.width <= 0 || rect.height <= 0) {
			$.set(crosshairUv, null);

			return;
		}

		const scaleX = canvas.width / rect.width;
		const scaleY = canvas.height / rect.height;
		const pixelX = (event.clientX - rect.left) * scaleX;
		const pixelY = (event.clientY - rect.top) * scaleY;

		$.set(crosshairUv, computeLutUv()(stepIndex(), pixelX, pixelY, canvas.width, canvas.height), true);
	}

	var $$exports = {
		get stepId() {
			return stepId();
		},

		set stepId($$value) {
			stepId($$value);
			$.flush();
		},

		get stepIndex() {
			return stepIndex();
		},

		set stepIndex($$value) {
			stepIndex($$value);
			$.flush();
		},

		get ariaLabel() {
			return ariaLabel();
		},

		set ariaLabel($$value) {
			ariaLabel($$value);
			$.flush();
		},

		get computeLutUv() {
			return computeLutUv();
		},

		set computeLutUv($$value = undefined) {
			computeLutUv($$value);
			$.flush();
		},

		get onCrosshairUvChange() {
			return onCrosshairUvChange();
		},

		set onCrosshairUvChange($$value = () => undefined) {
			onCrosshairUvChange($$value);
			$.flush();
		}
	};

	var aside = root();
	var canvas_1 = $.only_child(aside);

	$.template_effect(() => {
		$.set_attribute(canvas_1, 'data-step-id', stepId());
		$.set_attribute(canvas_1, 'aria-label', ariaLabel());
	});

	$.delegated('mousemove', canvas_1, handlePreviewMouseMove);

	$.event('mouseleave', canvas_1, () => {
		$.set(crosshairUv, null);
	});

	$.append($$anchor, aside);

	return $.pop($$exports);
}

$.delegate(['mousemove']);

$.create_custom_element(
	Svelte_step_preview,
	{
		stepId: {},
		stepIndex: {},
		ariaLabel: {},
		computeLutUv: {},
		onCrosshairUvChange: {}
	},
	[],
	[],
	{ mode: 'open' }
);